const state = {
    selTariff: null,
    tariffReq:null,
    selRatePlan:null,
  };
  
  const getters = {
    GET_SEL_TARIFF: (state) => {
      return state.selTariff;
    },
    GET_TARIFF_REQ: (state) => {
      return state.tariffReq;
    },
    GET_SEL_RATE_PLAN: (state) => {
      return state.selRatePlan;
    },
  };
  
  const actions = {
    CLEAR_TARIFF_STORE: ({ commit }) => {
        commit('clearTariffStore');
    },
    SET_SEL_TARIFF: ({ commit }, obj) => {
      commit("saveTariff", obj);
    },
    SET_TARIFF_REQ: ({ commit }, obj) => {
      commit("saveTariffReq", obj);
    },
    SET_SEL_RATE_PLAN: ({ commit }, obj) => {
      commit("saveSelRatePlan", obj);
    },
  };
  
  const mutations = {
    clearTariffStore: (state) => {
      state.selTariff = null;
      state.tariffReq = null;
      state.selRatePlan=null;

    },
  
    saveTariff: (state, obj) => {
      state.selTariff = obj;
    },
    saveTariffReq: (state, req) => {
      state.tariffReq = req;
    },
    saveSelRatePlan: (state, req) => {
      state.selRatePlan = req;
    },
  };
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
  